import React from "react";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { connect } from "react-redux";
import { compose, withHandlers } from "recompose";
import { forEach } from "lodash";
import Button from "react-md/lib/Buttons/Button";

import TextField from "../form/TextField";
import AutocompleteField from "../form/AutocompleteField";
import SelectField from "../form/SelectField";
import * as Validation from "../form/Validation";

import { inviteProvider } from "../../actions/requestActions";
import { getTypeBySearch } from "../../actions/resourceActions";

const SuppliersInviteForm = ( { handleSubmit, user, users, getTypeBySearch, change }) => {
  if (user) {
    const options = [{ label: user.identifier, value: user.identifier }];
    const optionsAutocomplete = [];
    if (users)
      forEach(users.item, item =>
        optionsAutocomplete.push({
          label: `${item.name
            ? `${item.name} (`
            : ""}${item.identifier}${item.name ? `)` : ""}`,
          value: item.identifier
        })
      );
    return (
      <form onSubmit={handleSubmit} className="form">
        <Field
          name="sender"
          label="Send as"
          component={SelectField}
          menuItems={options}
          validate={[Validation.required]}
        />
        <Field
          component={AutocompleteField}
          label="Komu"
          name="to"
          data={optionsAutocomplete}
          onChange={(e, value) => getTypeBySearch("PERSON", value)}
          onAutocomplete={value => {
            change("to", value);
          }}
          validate={[Validation.required]}
        />
        <Field
          component={TextField}
          label="Předmět"
          name="subject"
          validate={[Validation.required]}
        />
        <Field
          component={TextField}
          name="text"
          rows={10}
          validate={[Validation.required]}
        />
          <div style={{ height: '18px '}} />
        <div className="flex-row flex-right">
          <Button
            flat
            primary
            label="Odeslat"
            type="submit"
            className="btn btn-primary touchButton-6"
          />
        </div>
      </form>
    );
  }

  return <div />;
};

export default compose(
  connect(({ resource: { users } }) => ({ users }), {
    inviteProvider,
    getTypeBySearch
  }),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const { inviteProvider, history } = props;
      const { sender, to, subject, text } = formData;

      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(to)) {
        throw new SubmissionError({
          to: "Povinné"
        });
      }

      const response = await inviteProvider(sender, to, subject, text);

      if (response) {
        history.push(`/requests/${response.hash}`);
      } else {
        throw new SubmissionError({
          text: "Pozvání se nezdařilo."
        });
      }
    }
  }),
  reduxForm({ form: "suppliersInviteForm", enableReinitialize: true })
)(SuppliersInviteForm);



// WEBPACK FOOTER //
// ./src/components/suppliersInvite/SuppliersInviteForm.js